import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ParameterService } from 'src/app/service/parameter.service';

@Component({
  selector: 'app-c01-tv-frame',
  templateUrl: './c01-tv-frame.component.html',
  styleUrls: ['./c01-tv-frame.component.scss'],
})
export class C01TvFrameComponent {
  @Input() customClass: string = '';
  @Input() hasBlackOverlay?: boolean = true;

  public baseHref = environment.baseHref;
  public isHisenseBrand = false;
  constructor(private parameterService: ParameterService) {}

  ngOnInit(): void {
    this.isHisenseBrand = this.parameterService.isHisenseBrand();
  }

  public frameStyles = this.isHisenseBrand
    ? {
        'background-color': '#0e0e0f',
      }
    : {
        border: '20px solid',
        'border-image-slice': 1,
        'border-image-source':
          'linear-gradient(95deg,rgba(0, 0, 0, 1) 0%,rgba(75, 75, 75, 1) 50%,rgba(0, 0, 0, 1) 100%)',
      };
}
